// MOBILE MENU
// on document start
let isMobileMenuOpen = false;

document.addEventListener("DOMContentLoaded", function () {
  let mobileMenuBtn = document.querySelector("#btn-menu-mobile");

  mobileMenuBtn.addEventListener("click", toggleMobileMenu);

  //   on esc
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      if (isMobileMenuOpen) {
        toggleMobileMenu();
      }
    }
  });
});

function lockScroll() {
  document.body.classList.toggle("lock");
}

function toggleMobileMenu(e) {
  lockScroll();
  isMobileMenuOpen = !isMobileMenuOpen;
  // Toggle menu lines
  let menuLines;
  if (e) {
    menuLines = this.querySelector(".menu-lines");
  } else {
    menuLines = document.querySelector("#btn-menu-mobile .menu-lines");
  }

  menuLines.classList.toggle("active");

  // Show mobile Menu
  let mobileMenu = document.querySelector("#mobile-menu");
  mobileMenu.classList.toggle("active");
}

document.addEventListener("DOMContentLoaded", function () {
  let timer = document.querySelector("#timer");
  if (timer) {
    startTimer(timer);
  }
});

function startTimer(timer) {
  let timerDias = timer.querySelector("#dias");
  let timerHoras = timer.querySelector("#horas");
  let timerMinutos = timer.querySelector("#minutos");
  let timerSegundos = timer.querySelector("#segundos");

  // a cada segundo
  setInterval(function () {
    timerSegundos.textContent = parseInt(timerSegundos.textContent) - 1;
    if (timerSegundos.textContent < 0) {
      timerSegundos.textContent = 59;
      timerMinutos.textContent = parseInt(timerMinutos.textContent) - 1;
      if (timerMinutos.textContent < 0) {
        if (timerHoras == 0) {
          timerMinutos.textContent = 0;
        } else {
          timerMinutos.textContent = 59;
          timerHoras.textContent = parseInt(timerHoras.textContent) - 1;
          if (timerHoras.textContent < 0) {
            if (timerDias.textContent == 0) {
              timerHoras.textContent = 0;
            } else {
              timerHoras.textContent = 23;
              timerDias.textContent = parseInt(timerDias.textContent) - 1;
            }
          }
        }
      }
    }
  }, 1000);
}
